import queryString from "query-string"

/**
 * @deprecated DEPRECATED_MANAGE_ORG_NAV — consumes the old `/manage/organization` user-management nav.
 * Remove or repoint to `/reporting/organization` when that nav is deleted.
 */
export function hasPermissionQ(permissionType, role) {
  const permissions = [
    "Super Administrator",
    "ACT Admin",
    "District Admin",
    "Organization Admin",
    "School Admin",
    "Teacher"
  ]

  const sliceIndex = permissions.indexOf(role)
  return permissions.slice(sliceIndex).includes(permissionType)
}

/**
 * @deprecated DEPRECATED_MANAGE_ORG_NAV — consumes the old `/manage/organization` user-management nav.
 * Remove or repoint to `/reporting/organization` when that nav is deleted.
 */
export function getManageUsersSidebarLinks(user, schools, educators, location) {
  // if (!districts || !Object.keys(districts).length) return []

  const links = []
  const query = location ? queryString.parse(location.search) : {}
  // "/import" path should not be used to determine target query.
  const parts = location.pathname
    .split("/")
    .filter(path => path !== "import" && path !== "restore")
  const role = user ? user.role : null
  const state = user?.state || query.state
  const district = query.district || user?.schoolDistrict

  if (state) {
    query.state = state
  }

  if (district && role !== "Super Administrator") {
    query.district = district
  }

  if (hasPermissionQ("Super Administrator", role)) {
    links.push({
      name: "Districts",
      // @deprecated DEPRECATED_MANAGE_ORG_NAV — old `/manage/organization` nav usage; remove or repoint to `/reporting/organization` when that nav is deleted.
      link: `/manage/organization/districts${location.search}`,
      icon: "icon-globe"
    })
  }

  if (hasPermissionQ("District Admin", role)) {
    let forceDistrict = ""
    if (
      role === "District Admin" ||
      role === "ACT Admin" ||
      role === "Organization Admin"
    ) {
      forceDistrict = `${user.schoolDistrict}`
    }
    let qs = ""
    if (!forceDistrict) {
      if (parts.length === 5) {
        if (["school-admins", "teachers", "students"].includes(parts[3])) {
          const school = schools && schools[parts[4]]
          forceDistrict = school ? `${school.district}` : ""
        } else if (["district-admins", "schools"].includes(parts[3])) {
          forceDistrict = `${parts[4]}`
        } else if (["classes"].includes(parts[3])) {
          const teacher = educators && educators[parts[4]]
          forceDistrict = teacher ? `${teacher.schoolDistrict}` : ""
        }
      }
    }

    const newQuery = { ...query }

    if (forceDistrict) {
      newQuery["district"] = forceDistrict
    }

    qs = queryString.stringify(newQuery)

    links.push({
      name: "District Admins",
      // @deprecated DEPRECATED_MANAGE_ORG_NAV — old `/manage/organization` nav usage; remove or repoint to `/reporting/organization` when that nav is deleted.
      link: `/manage/organization/district-admins?${qs}`,
      icon: "icon-globe"
    })
    links.push({
      name: "Schools",
      // @deprecated DEPRECATED_MANAGE_ORG_NAV — old `/manage/organization` nav usage; remove or repoint to `/reporting/organization` when that nav is deleted.
      link: `/manage/organization/schools?${qs}`,
      icon: "icon-schools"
    })
  }

  if (hasPermissionQ("School Admin", role)) {
    let forceSchool = ""
    if (role === "School Admin") {
      forceSchool = `${user.school}`
    }
    let qs = ""

    if (!forceSchool) {
      if (parts.length === 5) {
        if (["school-admins", "teachers", "students"].includes(parts[3])) {
          forceSchool = parts[4]
        } else if (["district-admins", "schools"].includes(parts[3])) {
          qs = queryString.stringify({ state, district: parts[4] })
        } else if (["classes"].includes(parts[3])) {
          const teacher = educators && educators[parts[4]]
          qs = queryString.stringify({
            state,
            district: teacher ? teacher.schoolDistrict : "",
            sc: teacher ? teacher.school : ""
          })
        }
      } else {
        const newQuery = { ...query }
        qs = queryString.stringify(newQuery)
      }
    }

    const newQuery = { ...query }

    if (forceSchool) {
      newQuery["school"] = forceSchool
    }

    qs = queryString.stringify(newQuery)

    links.push({
      name: "School Admins",
      // @deprecated DEPRECATED_MANAGE_ORG_NAV — old `/manage/organization` nav usage; remove or repoint to `/reporting/organization` when that nav is deleted.
      link: `/manage/organization/school-admins?${qs}`,
      icon: "icon-people"
    })

    if (role === "School Admin") {
      forceSchool = `${user.school}`
    }

    if (!forceSchool && parts.length === 5) {
      if (["classes"].includes(parts[3])) {
        const teacher = educators && educators[parts[4]]
        forceSchool = teacher ? `${teacher.school || ""}` : ""
        qs = ""
      }
    }

    if (forceSchool) {
      newQuery["school"] = forceSchool
    }

    qs = queryString.stringify(newQuery)

    links.push({
      name: "Teachers",
      // @deprecated DEPRECATED_MANAGE_ORG_NAV — old `/manage/organization` nav usage; remove or repoint to `/reporting/organization` when that nav is deleted.
      link: `/manage/organization/teachers?${qs}`,
      icon: "icon-teachers"
    })
  }

  if (hasPermissionQ("Instructor", role)) {
    const forceTeacher = `/${user.id}`
    const forceSchool = ""

    const qs = { ...query, t: user.id }

    // if (!forceTeacher) {
    //   if (parts.length === 5) {
    //     let newQuery = {}
    //     if (["school-admins", "teachers", "students"].includes(parts[3])) {
    //       const school = schools && schools[parts[4]]
    //       if (school) {
    //         newQuery = { state, d: school.district, sc: parts[4] }
    //       }
    //     } else if (["district-admins", "schools"].includes(parts[3])) {
    //       newQuery = { state, d: parts[4] }
    //     }
    //     qs = newQuery
    //   } else {
    //     qs = query
    //   }
    // }

    links.push({
      name: "Classes",
      // @deprecated DEPRECATED_MANAGE_ORG_NAV — old `/manage/organization` nav usage; remove or repoint to `/reporting/organization` when that nav is deleted.
      link: `/manage/organization/classes?${queryString.stringify(qs)}`,
      icon: "icon-screen-desktop"
    })

    links.push({
      name: "Students",
      // @deprecated DEPRECATED_MANAGE_ORG_NAV — old `/manage/organization` nav usage; remove or repoint to `/reporting/organization` when that nav is deleted.
      link: `/manage/organization/students?${queryString.stringify(qs)}`,
      icon: "icon-graduation"
    })
  }

  if (hasPermissionQ("Teacher", role)) {
    let forceTeacher = ""
    let forceSchool = ""
    let qs = ""

    if (role === "Teacher") {
      forceTeacher = `${user.id}`
      const schoolId = user?.schools?.length ? user?.schools[0] : user.school

      forceSchool = `${schoolId}`

      qs = `sc=${schoolId}&district=${user.schoolDistrict}&state=${user.state}`
    } else if (role === "School Admin") {
      forceSchool = `${user.school}`
    }

    let newQuery = {}

    if (!forceTeacher) {
      if (parts.length === 5) {
        //let newQuery = {}
        if (["school-admins", "teachers", "students"].includes(parts[3])) {
          const school = schools && schools[parts[4]]
          if (school) {
            newQuery = {
              state,
              district: school.district,
              school: parts[4],
              state: school.state
            }
          }
        } else if (["district-admins", "schools"].includes(parts[3])) {
          newQuery = { state, district: parts[4] }
        }
        qs = queryString.stringify(newQuery)
      } else {
        qs = queryString.stringify(query)
      }
    }

    forceSchool && (newQuery["school"] = forceSchool)
    forceTeacher && (newQuery["teacher"] = forceTeacher)

    qs = queryString.stringify({ ...query, ...newQuery })

    links.push({
      name: "Classes",
      // @deprecated DEPRECATED_MANAGE_ORG_NAV — old `/manage/organization` nav usage; remove or repoint to `/reporting/organization` when that nav is deleted.
      link: `/manage/organization/classes?${qs}`,
      icon: "icon-screen-desktop"
    })

    newQuery = {}

    if (!forceSchool) {
      qs = ""
      if (parts.length === 5) {
        if (["school-admins", "teachers", "students"].includes(parts[3])) {
          forceSchool = `${parts[4]}`
        } else if (["district-admins", "schools"].includes(parts[3])) {
          qs = queryString.stringify({ state, district: parts[4] })
        } else if (["classes"].includes(parts[3])) {
          const teacher = educators && educators[parts[4]]
          forceSchool = teacher ? `${teacher.school || ""}` : ""
        }
      } else {
        newQuery = { ...query }
        qs = queryString.stringify(newQuery)
      }
    }

    if (forceSchool) {
      newQuery = { ...query }
      newQuery["school"] = forceSchool
    }

    qs = queryString.stringify(newQuery)

    links.push({
      name: "Students",
      // @deprecated DEPRECATED_MANAGE_ORG_NAV — old `/manage/organization` nav usage; remove or repoint to `/reporting/organization` when that nav is deleted.
      link: `/manage/organization/students?${qs}`,
      icon: "icon-graduation"
    })
  }

  return links
}
